import { Helmet } from 'react-helmet-async';
import SeoHeader from 'src/components/custom-header';
// routes
import { paths } from 'src/routes/paths';
// sections
import SecurityPageView from 'src/sections/legal/security-page/view';

// ----------------------------------------------------------------------

export default function Page() {
  return (
    <>
      <Helmet>
        <title>Security</title>
        <meta name="description" content="See Simple Translate Security" />
      </Helmet>

      <SecurityPageView />
    </>
  );
}
